import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-quote',
  templateUrl: './quote.component.html',
  styleUrls: ['./quote.component.scss'],
})
export class QuoteComponent {

    @Input()quote: String;
    @Input()quoteBy: String;
    static componentName = 'QuoteComponent';

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/quote/quote.component.ts